import {
  GuideNavLink,
  GuideNavSection,
} from '@app/modules/GuideV2/components/GuideSubTopicNavigation'
import { GuideSubTab } from '../types/guide.types'

export const groupByMainTopic = (subTabs: GuideSubTab[], mainTopic?: string): GuideNavSection[] => {
  const visibleTabs = subTabs.filter((tab) => tab.visible).sort((a, b) => a.order - b.order)

  const grouped = visibleTabs.reduce(
    (acc, tab) => {
      const sectionTitle = tab.main_topic?.title || ''
      if (!acc[sectionTitle]) {
        acc[sectionTitle] = []
      }

      const mainTopicSlug = mainTopic ?? tab.main_topic?.slug ?? ''
      acc[sectionTitle].push({
        title: tab.title,
        slug: `/app/guide/${mainTopicSlug}/${tab.slug}`,
      })

      return acc
    },
    {} as Record<string, GuideNavLink[]>,
  )

  return Object.entries(grouped).map(([title, links]) => ({
    title,
    links,
  }))
}
